'use strict';

/**
 * Persistencia de filtros de listado en sessionStorage
 * (sobrevive navegación a acciones/formularios y volver atrás).
 */

export function loadFiltrosSession(clave, defaults) {
  try {
    const saved = sessionStorage.getItem(clave);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed && typeof parsed === 'object') {
        return { ...defaults, ...parsed };
      }
    }
  } catch (_) { /* ignore */ }
  return { ...defaults };
}

export function saveFiltrosSession(clave, valores) {
  try {
    sessionStorage.setItem(clave, JSON.stringify(valores));
  } catch (_) { /* ignore */ }
}
